import fs from 'node:fs'
import { snapshotTargetPath } from '@core-engine/snapshots/store/snapshot-target-path.js'

export function readProjectFile(cwd: string, filePath: string): string | null {
  const fullPath = snapshotTargetPath(cwd, filePath)
  if (!fs.existsSync(fullPath)) {
    return null
  }

  return fs.readFileSync(fullPath, 'utf-8')
}
